import { useEffect } from 'react'
import { Outlet } from '@tanstack/react-router'
import { Toaster } from 'ui/sonner'

import './i18n'
import { BeforeInstallPromptProvider } from '~/providers/before-install-prompt-provider'
import { extractCssVariableValue } from '~/utils/extract-css-variable-value'
import { hslToHex } from '~/utils/hsl-to-hex'

import { getIsDarkMode } from './utils/get-is-dark-mode'
import { setMetaTheme } from './utils/set-meta-theme'

export const App = () => {
  useEffect(() => {
    if (getIsDarkMode()) {
      document.documentElement.classList.add('dark')
      setMetaTheme(hslToHex(extractCssVariableValue('--background')))
    }
  }, [])

  return (
    <BeforeInstallPromptProvider>
      <Outlet />
      <Toaster />
    </BeforeInstallPromptProvider>
  )
}
